export const pastaAndSandwiches = [
  {
    id: "1",
    name: "Alfredo Pasta",
    priceS: "500",
    priceL: "900",
  },
  {
    id: "2",
    name: "Macaroni Pasta",
    priceS: "460",
    priceL: "720",
  },
  {
    id: "3",
    name: "Creamy Chicken Pasta",
    priceS: "550",
    priceL: "950",
  },
  {
    id: "4",
    name: "Mexican Sandwich",
    priceS: "550",
    priceL: "",
  },
  {
    id: "5",
    name: "Club Sandwich",
    priceS: "350",
    priceL: "",
  },
  {
    id: "6",
    name: "Panini Sandwich",
    priceS: "350",
    priceL: "",
  },
  {
    id: "7",
    name: "Steak Sandwich",
    priceS: "450",
    priceL: "",
  },
];
